import { useMemo, useState, useCallback, useEffect } from 'react';

// TODO: refactor same as dropdown
export function useCheckboxListSelectedOptions(defaultValues=[], defaultOptions) {
  let [inited, setInited] = useState(false);
  let [options, setOptions] = useState(defaultOptions);

  useEffect(() => {
    let newOptions = defaultOptions.map(x => ({ ...x }));

    if (!inited) {
      for (let value of defaultValues || []) {
        if (value.isGroup) {
          for (let option of newOptions.filter(x => x.group === value.name)) {
            option.isChecked = true;
          }
        } else {
          let option = newOptions.find(x => x.value === value.value);

          if (option) {
            option.isChecked = true;
          } else {
            let groupIndex = newOptions.findIndex(x => x.isGroup && x.group === value.group);

            if (groupIndex !== -1) newOptions.splice(groupIndex + 1, 0, { ...value, isChecked: true });
          }
        }
      }

      setInited(true);
    }

    setOptions(newOptions);
  }, [defaultOptions]);

  let checked = useMemo(() => {
    let selectedGroups = new Set(options.filter(x => x.isGroup && x.isChecked).map(x => x.group));

    let selectedOptions = options.filter(x => x.isChecked && (x.isGroup || !selectedGroups.has(x.group)));

    if (!selectedOptions.length || selectedOptions[0].value === 'any') return null;

    return selectedOptions;
  }, [options]);

  let onToggle = useCallback((option) => {
    let newOptions = [...options];

    if (option.value === 'any') {
      newOptions = newOptions.map(x => ({ ...x, isChecked: !option.isChecked }));
    } else if (option.isGroup) {
      newOptions = newOptions.map(x => x.group === option.group ? ({ ...x, isChecked: !option.isChecked}) : x);
    } else {
      newOptions[options.indexOf(option)] = { ...option, isChecked: !option.isChecked };
    }

    let groups = newOptions.filter(x => x.isGroup);
    let any = newOptions[0];

    for (let group of groups) {
      let groupOptions = newOptions.filter(x => x.group === group.group && !x.isGroup);

      if (group.isChecked && groupOptions.some(x => !x.isChecked)) {
        newOptions = newOptions.map(x => x === group ? ({ ...x, isChecked: false }) : x);
      } else if (!group.isChecked && groupOptions.every(x => x.isChecked)) {
        newOptions = newOptions.map(x => x === group ? ({ ...x, isChecked: true }) : x);
      }
    }

    if (any.isChecked && newOptions.some(x => !x.isChecked)) {
      newOptions[0] = { ...any, isChecked: false };
    } else if (!any.isChecked && newOptions.every(x => x === any || x.isChecked)) {
      newOptions[0] = { ...any, isChecked: true };
    }

    setOptions(newOptions);
  }, [options]);

  return {
    options,
    checked,
    onToggle,
  };
}

// TODO: rework updateQuery and setFilters to useContext?
export function useCheckboxListOptionsChange({
  options,
  filterKey,
  filterValueKey,
  filterGroupKey,
  setFilters,
  queryKey=filterKey,
  queryValueKey=filterValueKey,
  queryGroupKey=filterGroupKey,
  updateQuery,
}) {
  useEffect(() => {
    let filtersValues = [];
    let queryValues = [];

    if (!options || !options.length) {
      filtersValues = null;
      queryValues = undefined;
    } else {
      for (let option of options) {
        let fitlerValue = { [filterGroupKey]: option.group };
        let queryValue = { [queryGroupKey]: option.group };

        if (!option.isGroup) {
          fitlerValue[filterValueKey] = option.value;
          queryValue[queryValueKey] = option.value;
        }

        filtersValues.push(fitlerValue);
        queryValues.push(queryValue);
      }
    }

    setFilters(x => ({ ...x, [filterKey]: filtersValues }));
    updateQuery({ [queryKey]: queryValues });
  }, [options]);
}
